<template>
	<div>
		<div class="content-header text-center">
            <div class="float-start" v-if="projectrefer"><button @click="backToProjects(projectrefer)" class="btn btn-blank"><i class="fas fa-arrow-left"></i> {{projectrefer}} Details</button></div>
			<h2>{{passedData}}</h2>
		</div>
		<div class="tabbed-padding">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" v-for="(tab, index) in tabs" :key = "index" role="presentation">
                    <button class="nav-link" :class="{ active: activeTab === index }" :id="`tab-${index}`" data-bs-toggle="tab" :data-bs-target="`#content-${index}`" type="button" role="tab" :aria-controls="`content-${index}`" :aria-selected="activeTab === index" @click="activeTab = index">{{ tab.title }}</button>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade" :class="{ show: activeTab === index, active: activeTab === index }" :id="`content-${index}`" role="tabpanel" :aria-labelledby="`tab-${index}`" v-for="(tab, index) in tabs" :key="index">
                    <component :is="tab.component" v-bind:passedData="passedData"></component>
                </div>
            </div>
		</div>
	</div>
</template>
<script>
import DataTableData from './DataTableData.vue';
import DataTablePropensity from './DataTablePropensity.vue';
import DataTableLink from './DataTableLink.vue';
export default {
    name: 'Dataset Shell',
    components: {
        DataTableData,
        DataTablePropensity,
        DataTableLink
    },
    props: {
        passedData: {
        type: String,
        default() {
            return 'Dataset'
        }
        },
        projectrefer: ''
    },
    data() {
        return {
             tabs: [
            { title: 'Original Upload', component: 'DataTableData' },
            { title: 'Propensity Model', component: 'DataTablePropensity' },
            { title: 'Appended Consumer Data', component: 'DataTableLink' }
          ],
          activeTab: 0
        }
    },
    methods: {
        backToProjects(referval) {
            this.$emit('customChangeProject', {shell: 'ProjectDetails', dataset: referval})
        }
    },
    mounted() {
        console.log('projectrefer value is: '+this.projectrefer);
  }
}
</script>